module.exports = __webpack_public_path__ + "static/media/marketing.45dc786a.svg";